import Images from "./Images";
import T from "./Technologies";

// Projects whose source code is private (client work or proprietary products).
// Open-source projects live on Dueffe Home: see ProjectCatalog.js.
const ClosedSourceProjects = [
    {
        id: 'iron-pump',
        name: 'Iron Pump',
        icon: Images.ironPumpIcon,
        accent: '#f97316',
        technology: [T.REACT, T.VITE, T.JAVA, T.SPRING_BOOT, T.MONGODB, T.INDEXEDDB],
        category: { it: 'Gestionale', en: 'Management software' },
        description: {
            it: 'Gestionale per palestre con fatturazione, inserimento utenti, timbrata ingresso, scadenze e tanto altro!',
            en: 'Management software for gyms with billing, user registration, entry stamping, deadlines, and much more!',
        },
        link: null,
    },
    {
        id: 'teglia-re',
        name: 'Teglia Rè',
        icon: Images.tegliareIcon,
        iconFit: 'contain',
        iconBackground: '#050505',
        accent: '#eab308',
        technology: [T.REACT],
        category: { it: 'Sito vetrina', en: 'Showcase website' },
        description: {
            it: 'Sito vetrina per Teglia Rè, pizzeria romana a Roma, con menu online e proposte di pizza in teglia, tonde, pinse, fritti e dolci.',
            en: 'Showcase website for Teglia Rè, a Roman pizzeria in Rome, with an online menu featuring pizza in teglia, round pizzas, pinsa, fried food, and desserts.',
        },
        link: 'https://tegliare.it/',
    },
    {
        id: 'popina',
        name: 'Popina',
        icon: Images.popinAppIcon,
        accent: '#ef4444',
        technology: [T.REACT, T.TYPESCRIPT, T.VITE, T.FIREBASE],
        category: { it: 'PWA fidelizzazione', en: 'Loyalty PWA' },
        description: {
            it: 'Popina è una PWA per la fidelizzazione dei clienti di un ristorante romano.',
            en: 'Popina is a PWA for customer loyalty at a Roman restaurant.',
        },
        link: null,
    },
];

export default ClosedSourceProjects;
